import React, { useEffect, useState } from "react";
import { FaHeart, FaStar, FaPhoneAlt } from "react-icons/fa";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Confirm } from "notiflix";
import { useNavigate } from "react-router-dom";
import { Notify } from "notiflix";
export default function MyProfile() {
    const Navigate = useNavigate();
    const [Data, setData] = useState([]);
    const [ProfilePic, setProfilePic] = useState("");
    const [RasiChartData, setRasiChartData] = useState([]);
    const [AmsamChartData, setAmsamChartData] = useState([]);
    const [Reload, setReload] = useState(false);

    const [IntretedStatus, setIntrestedStatus] = useState("");
    const [ShortListStatus, setShortListStatus] = useState("");
    const [MobileNumberStatus, setMobileNumberStatus] = useState("");
    const [RasiChart, setRasiChart] = useState({
        r1: "", r2: "", r3: "", r4: "", r5: "", r6: "",
        r7: "", r8: "", r9: "", r10: "", r11: "", r12: ""
    });

    const [AmsamChart, setAmsamChart] = useState({
        a1: "", a2: "", a3: "", a4: "", a5: "", a6: "",
        a7: "", a8: "", a9: "", a10: "", a11: "", a12: ""
    });

    const profile = {
        profile_id: Data.profile_id,
        name: Data.name,
        gender: Data.gender,
        birth_date: Data.birth_date,
        birth_time: Data.birth_time,
        age:Data.age,
        birth_place: Data.birth_place,
        mobile_number: MobileNumberStatus == 0 ? '+' + 91 + ' xxxxx' + Data.mobile_number?.split("").splice(5, 10).join("") : Data.mobile_number,
        alternative_number: MobileNumberStatus == 0 ? '+' + 91 + ' xxxxx' + Data.alternative_number?.split("").splice(5, 10).join("") : Data.alternative_number,
        education: Data.education,
        job_description: Data.job_description,
        work_place: Data.work_place,
        blood_group: Data.blood_group,
        body_type: Data.body_type,
        height: Data.height,
        weight: Data.weight,
        color: Data.color,
        monthly_income: Data.monthly_income,
        caste: Data.caste,
        kulam: Data.kulam,
        kula_deivam: Data.kula_deivam,
        jathagam: Data.jathagam,
        star: Data.star,
        rasi: Data.rasi,
        laknam: Data.laknam,
        martial_status: Data.martial_status,
        father_name: Data.father_name,
        mother_name: Data.mother_name,
        expectation: Data.expectation,
        father_job_description: Data.father_job_description,
        mother_job_description: Data.mother_job_description,
        living_place: Data.living_place,
        siblings: Data.siblings,
        property_details: Data.property_details,
        current_living_place: Data.current_living_place,
    };


  const detailsEntries = Object.entries({
    "Profile ID": profile.profile_id,
    Gender: profile.gender,
    "Marital Status": profile.martial_status,
    "Age":profile.age,
    Jathagam: profile.jathagam,
    "Birth Date": profile.birth_date,
    "Birth Time": profile.birth_time,
    Age: profile.age,
    "Birth Place": profile.birth_place,
    "Living Place": profile.living_place,
    Education: profile.education,
    Job: profile.job_description,
    "Work Place": profile.work_place,
    "Monthly Income": profile.monthly_income,
    "Blood Group": profile.blood_group,
    Caste: profile.caste,
    Kulam: profile.kulam,
    Kuladeivam: profile.kula_deivam,
    Color: profile.color,
    Height: profile.height,
    Weight: profile.weight,
    Star: profile.star,
    Rasi: profile.rasi,
    Laknam: profile.laknam ?? "-",
    "Father Name": profile.father_name,
    "Father Job": profile.father_job_description,
    "Mother Name": profile.mother_name,
    "Mother Job": profile.mother_job_description,
    Siblings: profile.siblings,
    Expectation: profile.expectation,
    Property: profile.property_details,
    "Mobile Number": profile.mobile_number,
    "Alternative Number": profile.alternative_number,
});

    const half = Math.ceil(detailsEntries.length / 2);
    const firstHalf = detailsEntries.slice(0, half);
    const secondHalf = detailsEntries.slice(half);

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/myprofile",
                { headers }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setData(response.data.profile_data);
                    setProfilePic(response.data.profile_data.profile_photo_1)
                    let rasidata = response.data.rasi_chart;
                    let amsamData = response.data.amsam_chart
                    setIntrestedStatus(response.data.profile_data.intrest_status);
                    setShortListStatus(response.data.profile_data.short_list_status);
                    setMobileNumberStatus(response.data.profile_data.mobile_number_status);
                    setRasiChart({
                        r1: rasidata.r1, r2: rasidata.r2, r3: rasidata.r3, r4: rasidata.r4, r5: rasidata.r5, r6: rasidata.r6,
                        r7: rasidata.r7, r8: rasidata.r8, r9: rasidata.r9, r10: rasidata.r10, r11: rasidata.r11, r12: rasidata.r12
                    })
                    setAmsamChart({
                        a1: amsamData.a1, a2: amsamData.a2, a3: amsamData.a3, a4: amsamData.a4, a5: amsamData.a5, a6: amsamData.a6,
                        a7: amsamData.a7, a8: amsamData.a8, a9: amsamData.a9, a10: amsamData.a10, a11: amsamData.a11, a12: amsamData.a12
                    });
                    setRasiChartData(response.data.rasi_chart);
                    setAmsamChartData(response.data.amsam_chart);
                } else {
                    Notify.failure(response.data.message);
                }
            });
    }, []);


    const renderTable = (chart, chartName) => (
        <table className="birth-table-2 m-auto" cellSpacing="0" cellPadding="0">
            <tbody>
                <tr>
                    <td>{chart[chartName + "12"]}</td>
                    <td>{chart[chartName + "1"]}</td>
                    <td>{chart[chartName + "2"]}</td>
                    <td>{chart[chartName + "3"]}</td>
                </tr>
                <tr>
                    <td>{chart[chartName + "11"]}</td>
                    <td
                        className="chart-birth text-center"
                        width="220"
                        height="220"
                        colSpan="2"
                        rowSpan="2"
                    >
                        <p className="rasi-chart">{chartName === "r" ? "ராசி" : "நவாம்சம்"}</p>
                    </td>
                    <td>{chart[chartName + "4"]}</td>
                </tr>
                <tr>
                    <td>{chart[chartName + "10"]}</td>
                    <td>{chart[chartName + "5"]}</td>
                </tr>
                <tr>
                    <td>{chart[chartName + "9"]}</td>
                    <td>{chart[chartName + "8"]}</td>
                    <td>{chart[chartName + "7"]}</td>
                    <td>{chart[chartName + "6"]}</td>
                </tr>
            </tbody>
        </table>
    );

    return (
        <>
            <div className="top-card d-flex justify-content-center mt-4">
                <div className="profile-image-section">
                    <img src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${Data.profile_photo_1}`} alt={profile.name} />
                </div>
                <div className="profile-image-section">
                    <img src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${Data.profile_photo_2}`} alt={profile.name} />
                </div>
                <div className="profile-image-section">
                    <img src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/horoscope_images/${Data.horoscope_photo}`} alt={profile.name} />
                </div>

                <div className="right-section">
                    <h2 className="profile-name">{profile.name}</h2>
                
                </div>
            </div>

            <div className="details-card">
                <h3 className="profile-name-head">Profile Details</h3>
                <div className="details-table-wrapper">
                    <table className="details-table">
                        <tbody>
                            {firstHalf.map(([label, value]) => (
                                <tr key={label}>
                                    <td className="label">{label}</td>
                                    <td className="colon">:</td>
                                    <td className="value">{value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <table className="details-table">
                        <tbody>
                            {secondHalf.map(([label, value]) => (
                                <tr key={label}>
                                    <td className="label">{label}</td>
                                    <td className="colon-1">:</td>
                                    <td className="value">{value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="kattam-container">
                <h3 className="profile-name-head">Jathaga Kattam</h3>
                <div className="kattam-table-wrapper">
                    {renderTable(RasiChart, "r")}
                    {renderTable(AmsamChart, "a")}
                </div>
            </div>
        </>
    );
}
